import { useState, useRef, useEffect } from "react";
import { CgFileAdd } from "react-icons/cg";
import { buttonloginstyle } from "../help/Utils";
import { VisaType } from "../API/visaEligibilityAPI";

const StartNewApplicationDropdown: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  // Outside click handler
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const applicationTypes = Object.values(VisaType).map((type) => ({
    label: type,
    link: `/visa-eligibility/${type}`,
  }));

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      {/* Button */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center md:w-auto w-fill"
        style={buttonloginstyle}
      >
        <CgFileAdd className="text-[30px]" />
        <span className="ml-2">Start New Application</span>
      </button>

      {/* Dropdown menu */}
      {open && (
        <div className="absolute right-0 mt-2 md:w-[27rem] w-[100%] bg-white border border-gray-200 rounded-xl shadow-lg z-50">
          <ul className="p-6">
            {applicationTypes.map((item, idx) => (
              <li key={idx}>
                <a
                  href={item.link}
                  className="block px-4 py-4 text-lg text-gray-700 font-bold hover:bg-gray-100"
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default StartNewApplicationDropdown;
